import { render, staticRenderFns } from "./ComplexBorderRadius.vue?vue&type=template&id=17c1c6eb&scoped=true"
import script from "./ComplexBorderRadius.vue?vue&type=script&lang=js"
export * from "./ComplexBorderRadius.vue?vue&type=script&lang=js"
import style0 from "./ComplexBorderRadius.vue?vue&type=style&index=0&id=17c1c6eb&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1c6eb",
  null
  
)

export default component.exports